import { durations, easings, colors } from '../../constants';
import {
  mq,
  // mqH,
  mqLandscape,
} from '../../utils/mediaQuery';

export const pillarContainer = {
  width: '38px',
  position: 'relative',
  height: '100%',
  willChange: 'transform, opacity',
  transformStyle: 'preserve-3d',
  backfaceVisibility: 'hidden',
  // '&:first-of-type': {
  //   marginRight: '20px',
  //   [mq('sm')]: {
  //     marginRight: '30px',
  //   },
  //   [`${mqLandscape}`]: {
  //     marginRight: '20px',
  //   },
  //   [`${mq('sm')} and (orientation: portrait)`]: {
  //     marginRight: '30px',
  //   },
  //   [mq('md')]: {
  //     marginRight: '30px',
  //   },
  // },
  [`${mqLandscape}`]: {
    width: '36px',
  },
  [mq('sm')]: {
    width: '36px',
  },
};

export const singlePillarContainer = (backgroundPillar) => {
  const style = {
    transform: 'translateY(10px)',
    opacity: 0,
    display: 'flex',
    width: 28,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',
  };

  if (!backgroundPillar) {
    // style['&:first-of-type'] = {
    //   marginRight: '40px',
    //   [`${mqLandscape}`]: {
    //     marginRight: '70px',
    //   },
    //   [`${mq('sm')} and ${mqH('xs')}`]: {
    //     marginRight: '70px',
    //   },
    // };

    style[`${mqLandscape}`] = {
      width: 21,
    };

    style[mq('sm')] = {
      width: 21,
    };

    style[mq('lg')] = {
      width: 28,
    };
  } else {
    style.width = 10;

    style[`${mqLandscape}`] = {
      width: 10,
    };

    style[mq('sm')] = {
      width: 15,
    };

    // style['&:first-of-type'] = {
    //   marginRight: 5,
    // };
  }

  return style;
};

export const pillarStyling = {
  background: '#e7e7e7',
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  overflow: 'hidden',
  transformStyle: 'preserve-3d',
  backfaceVisibility: 'hidden',
};

export const pillarSide = (
  direction,
  color,
  hasScaledPillar,
  showPillarGradient,
) => {
  const style = {
    width: '4px',
    height: '100%',
    overflow: 'hidden',
    position: 'relative',
  };

  if (hasScaledPillar) {
    style[`${mqLandscape}`] = {
      width: `3px`,
    };
    style[mq('sm')] = {
      width: `3px`,
    };
    style[mq('lg')] = {
      width: `4px`,
    };
  } else {
    style.width = '2px';
  }

  if (color === 'green') {
    if (direction === 'left') {
      style.background = `
        linear-gradient(
          0deg,
          #0b5f5f 39.86%,
          #32afad 72.87%,
          #48dcd9 100%
          );`;
      if (!hasScaledPillar && !showPillarGradient) {
        style.background = colors.flatGreenLight;
      }
    } else if (direction === 'right') {
      style.background = `
      linear-gradient(
        0deg,
        #063333 39.86%,
        #124544 72.87%,
        #363c45 100%
        );`;
      if (!hasScaledPillar && !showPillarGradient) {
        style.background = colors.flatGreenDark;
      }
    } else if (direction === 'topLeft') {
      style.background = `linear-gradient(0deg, #32afad 16.81%, #48dcd9 100%)`;
    } else if (direction === 'topRight') {
      style.background = `linear-gradient(0deg, #124544 16.81%, #363c45 100%)`;
    } else if (direction === 'bottomLeft') {
      style.background = `linear-gradient(0deg, #0b5f5f 16.81%, #32afad 100%)`;
    } else if (direction === 'bottomRight') {
      style.background = `linear-gradient(0deg, #063333 16.81%, #124544 100%)`;
    }
  } else if (color === 'blue') {
    if (direction === 'left') {
      style.background = `
      linear-gradient(
        0deg,
        #0c4acc 25.95%,
        #80a2df 66.6%,
        #cadfff 100%
        );`;
      if (!hasScaledPillar && !showPillarGradient) {
        style.background = colors.flatBlueLight;
      }
    } else if (direction === 'right') {
      style.background = `
        linear-gradient(
        0deg,
        #062361 25.95%,
        #38455c 66.6%,
        #363c45 100%
        );`;
      if (!hasScaledPillar && !showPillarGradient) {
        style.background = colors.flatBlueDark;
      }
    } else if (direction === 'topLeft') {
      style.background = `linear-gradient(0deg, #8babe4 16.81%, #cadfff 100%)`;
    } else if (direction === 'topRight') {
      style.background = `linear-gradient(0deg, #38455c 16.81%, #363c45 100%)`;
    } else if (direction === 'bottomleft') {
      style.background = `linear-gradient(0deg, #0c4acc 16.81%, #80a2df 100%)`;
    } else if (direction === 'bottomRight') {
      style.background = `linear-gradient(0deg, #062361 16.81%, #38455c 100%)`;
    }
  } else if (color === 'detailGreen') {
    style.width = '4px';
    if (direction === 'bottomLeft') {
      style.background = `linear-gradient(0deg, #32AFAD 16.81%, #48DCD9 100%);`;
    } else if (direction === 'bottomRight') {
      style.background = `linear-gradient(0deg, #124544 16.81%, #363C45 100%);`;
    }
  } else if (color === 'detailBlue') {
    style.width = '4px';
    if (direction === 'bottomLeft') {
      style.background = `linear-gradient(0deg, #8BABE4 16.81%, #CADFFF 100%);`;
    } else if (direction === 'bottomRight') {
      style.background = `linear-gradient(0deg, #38455C 16.81%, #363C45 100%);`;
    }
  }

  return style;
};

export const nonScaled = (
  color,
  hasScaledPillar,
  showPillarGradient,
  pillarPosition,
) => {
  const style = {
    position: 'absolute',
    width: '100%',
    bottom: 0,
    borderRadius: '0px 3px 0px 0px',
    zIndex: 1,
  };

  if (!hasScaledPillar) {
    style.position = 'relative';
    style.borderRadius = '0';
  }

  if (color === 'green') {
    style.background = `
    linear-gradient(
        0deg,
        #0a5656 16.81%,
        #2b9a98 62.48%,
        #41c7c4 100%
    );`;
    if (!hasScaledPillar) {
      style.background = colors.flatGreen;
    }
  } else if (color === 'blue') {
    style.background = `
    linear-gradient(
        0deg,
        #0b43b9 16.81%,
        #698bc5 62.48%,
        #b8cbe7 100%
    );`;
    if (!hasScaledPillar) {
      style.background = colors.flatBlue;
    }
  } else if (color === 'detailGreen') {
    style.background = `
    linear-gradient(
        0deg, 
        #2B9A98 16.81%, 
        #41C7C4 100%
    );`;
  } else if (color === 'detailBlue') {
    style.background = `
    linear-gradient(
      0deg,
      #698BC5 16.81%,
      #B8CBE7 100%
    );`;
  }

  if (showPillarGradient && !hasScaledPillar) {
    if (pillarPosition === 'top') {
      style.borderRadius = '3px 3px 0px 0px';

      if (color === 'green') {
        style.background = `linear-gradient(0deg, #2b9a98 16.81%, #41c7c4 100%)`;
      } else {
        style.background = `linear-gradient(0deg, #698bc5 16.81%, #b8cbe7 100%);`;
      }
    } else {
      if (color === 'green') {
        style.background = `linear-gradient(0deg, #0B5F5F 16.81%, #32AFAD 62.48%, #48DCD9 100%);`;
      } else {
        style.background = `linear-gradient(0deg, #0B43B9 16.81%, #698BC5 62.48%, #B8CBE7 100%);`;
      }
    }
  }

  return style;
};

export const scaled = (position, color) => {
  const style = {
    position: 'absolute',
    width: '100%',
    willChange: 'transform',
  };

  if (position === 'top') {
    style.borderRadius = '5px 5px 0px 0px';

    if (color === 'green') {
      style.background = `linear-gradient(0deg, #2b9a98 16.81%, #41c7c4 100%)`;
    } else {
      style.background = `linear-gradient(0deg, #698bc5 16.81%, #b8cbe7 100%);`;
    }
  } else {
    style.bottom = 0;

    if (color === 'green') {
      style.background = `linear-gradient(0deg, #0a5656 16.81%, #2b9a98 100%)`;
    } else {
      style.background = `linear-gradient(0deg, #0b43b9 16.81%, #698bc5 100%)`;
    }
  }

  return style;
};

export const reveal = {
  position: 'absolute',
  backgroundColor: colors.black,
  height: '100%',
  width: 'calc(100% + 2px)',
  left: -1,
  bottom: 0,
  zIndex: 1,
  transform: `translateY(0%)`,
  transition: `transform ${
    durations.revealPillarDuration + durations.revealPillarDuration * 0.36 * 8
  }ms ${easings.pillarReveal}`,
};
